import { useEffect, useState } from "react";
import { connect } from "react-redux";
import { useLocation } from "react-router-dom";
import Select from "react-select";
import { GetAllMasterDataBranchPayloadType } from "../../../commonTypes/masterDataTypes";
import { RadioTypes } from "../../../commonTypes/universalTypes";
import { EMPLOYMENT_STATUS } from "../../../constant/userProfileConstant";
import useDebounce from "../../../customHooks/useDebounce";
import { resetSession } from "../../../redux/auth";
import { HRSettingsType, UserProfileType } from "../../../redux/auth/authTypes";
import {
  getAllMasterDataBranchAction,
  resetMasterError,
  resetMasterMessage,
  resetMasterSuccess,
} from "../../../redux/masterData";
import { RootState } from "../../../redux/rootReducers";
import { RadioContainer, ToggleSwitch } from "../../commons";

type AppProps = {
  data: HRSettingsType;
  handleWorkDeatilsForm: (data: any) => void;
  setProfileForm: any;
  masterDataListing: [];
  fetching: boolean;
  message: string;
  success: null | number;
  error: null | string;
  statusCode: null | number;
  token: null | string;
  dispatchResetSession: () => void;
  dispatchResetMasterSuccess: () => void;
  dispatchResetMasterMessage: () => void;
  dispatchResetMasterError: () => void;
  dispatchGetMasterDataBranch: (
    data: GetAllMasterDataBranchPayloadType
  ) => void;
  masterDataBranchListTotal: string | number;
  masterDataFetching: boolean;
};

type UserListType = {
  label: string | null | undefined;
  value: number | null | undefined | string;
};

type OptionType = {
  value: string;
  label: string;
};
type CheckBoxType = {
  is_partner_field: boolean;
  is_manager_field: boolean;
  is_track_scheduling: boolean;
  is_track_efficiency: boolean;
  is_govt_officer: boolean;
};

const DAY_STATUS_RADIO_OPTIONS: RadioTypes[] = [
  {
    id: "5",
    name: "5",
  },
  {
    id: "6",
    name: "6",
  },
];

const WorkDetails = ({
  data,
  handleWorkDeatilsForm,
  setProfileForm,
  masterDataListing,
  fetching,
  message,
  success,
  error,
  token,
  statusCode,
  dispatchResetMasterError,
  dispatchResetSession,
  dispatchResetMasterSuccess,
  dispatchResetMasterMessage,
  dispatchGetMasterDataBranch,
  masterDataBranchListTotal,
  masterDataFetching,
}: AppProps) => {
  const { pathname } = useLocation();
  let show = pathname.includes("external-user");
  const [checkBoxData, setCheckBoxData] = useState<CheckBoxType>({
    is_partner_field: false,
    is_manager_field: false,
    is_track_scheduling: false,
    is_track_efficiency: false,
    is_govt_officer: false,
  });
  const [selectBranch, setSelectBranch] = useState({
    label: "Select Branch",
    value: "",
  });

  const [selectedUserBranch, setSelectedUserBranch] = useState<any>(null);
  const [finalUserList, setFinalUserList] = useState<UserListType[] | []>([]);
  const [branchList, setBranchList] = useState<any[]>([]);
  const [offset, setOffset] = useState(0);
  const [limit, setLimit] = useState(20);
  const [searchBranch, setSearchBranch] = useState("");
  const [searchClear, setSearchClear] = useState(false);
  const [weekDays, setWeekDays] = useState(5);
  useEffect(() => {
    if (token) {
      let finalData: GetAllMasterDataBranchPayloadType = {
        token,
        limit,
        offset,
        search_term: searchBranch,
        branch_status: 1,
      };
      if (offset < +masterDataBranchListTotal) {
        dispatchGetMasterDataBranch(finalData);
      } else if (offset === 0 && masterDataBranchListTotal === "") {
        dispatchGetMasterDataBranch(finalData);
      }
    }
  }, [offset]);

  const fetchNewData = (search: string) => {
    setSearchClear(true);
    let finalData: GetAllMasterDataBranchPayloadType = {
      token,
      limit,
      offset,
      search_term: searchBranch,
      branch_status: 1,
    };
    dispatchGetMasterDataBranch(finalData);
  };

  useDebounce(
    () => {
      if (searchBranch) {
        fetchNewData(searchBranch);
      }
    },
    500,
    [searchBranch]
  );

  useEffect(() => {
    if (searchClear) {
      let finalData: GetAllMasterDataBranchPayloadType = {
        token,
        limit,
        offset,
        search_term: searchBranch,
        branch_status: 1,
      };
      if (searchBranch?.length === 0) {
        dispatchGetMasterDataBranch(finalData);
        setOffset(0);
      }
    }
  }, [searchBranch, searchClear]);

  useEffect(() => {
    if (data?.work_details?.user_branch) {
      setSelectBranch((prv: any) => {
        if (data?.work_details?.user_branch?.branch_name) {
          return {
            label: data?.work_details?.user_branch?.branch_name,
            value: data?.work_details?.user_branch?._id,
          };
        } else if (data?.work_details?.user_branch?.label) {
          return {
            label: data?.work_details?.user_branch?.label,
            value: data?.work_details?.user_branch?.value,
          };
        } else {
          return {
            value: "",
            label: "",
          };
        }
      });
    }
  }, []);

  useEffect(() => {
    if (data?.working_days) {
      setWeekDays(data?.working_days);
    }
  }, [data?.working_days]);

  useEffect(() => {
    if (masterDataListing && masterDataListing?.length > 0) {
      let finalData: any[] = masterDataListing.map((el: any) => {
        return {
          label: el?.branch_name,
          value: el?._id,
        };
      });
      if (offset > 0) {
        setBranchList([...branchList, ...finalData]);
      } else {
        setBranchList([...finalData]);
      }
      // setBranchList(finalData)
    }
  }, [masterDataListing]);

  useEffect(() => {
    if (masterDataListing?.length > 0) {
      let finalData: any[] = masterDataListing.map((el: any) => {
        return {
          label: el?.branch_name,
          value: el?._id,
        };
      });

      if (offset > 0) {
        setBranchList((prv) => [...prv, ...finalData]);
      } else {
        setBranchList([...finalData]);
      }
    }
  }, [masterDataListing]);

  const checkBottom = () => {
    setOffset((prv: any) => prv + limit);
  };

  useEffect(() => {
    if (data?.work_details?.is_partner_field) {
      setCheckBoxData((prv: CheckBoxType) => ({
        ...prv,
        is_partner_field: true,
      }));
    }
    if (data?.work_details?.is_track_scheduling) {
      setCheckBoxData((prv: CheckBoxType) => ({
        ...prv,
        is_track_scheduling: true,
      }));
    }
    if (data?.work_details?.is_manager_field) {
      setCheckBoxData((prv: CheckBoxType) => ({
        ...prv,
        is_manager_field: true,
      }));
    }
    if (data?.work_details?.is_track_efficiency) {
      setCheckBoxData((prv: CheckBoxType) => ({
        ...prv,
        is_track_efficiency: true,
      }));
    }
    if (data?.is_govt_officer) {
      setCheckBoxData((prv: CheckBoxType) => ({
        ...prv,
        is_govt_officer: true,
      }));
    }
  }, [
    data?.work_details?.is_track_scheduling,
    data?.work_details?.is_manager_field,
    data?.work_details?.is_partner_field,
    data?.work_details?.is_track_efficiency,
    data?.is_govt_officer,
  ]);

  const handleBranch = (data: any) => {
    setSelectBranch((prv: any) => {
      return { label: data?.label, value: data?.value };
    });
    setSelectedUserBranch(data?.value);
  };

  useEffect(() => {
    if (selectedUserBranch || selectBranch?.value) {
      setProfileForm((prv: UserProfileType) => {
        return {
          ...prv,
          hr_settings: {
            ...prv.hr_settings,
            work_details: {
              ...prv.hr_settings.work_details,
              user_branch: selectBranch,
            },
          },
        };
      });
    }
  }, [selectedUserBranch, selectBranch]);

  function changePartnerFieldCheckBox() {
    setCheckBoxData((prv: CheckBoxType) => ({
      ...prv,
      is_partner_field: !checkBoxData.is_partner_field,
    }));
  }
  function changeGovtFieldCheckBox() {
    setCheckBoxData((prv: CheckBoxType) => ({
      ...prv,
      is_govt_officer: !checkBoxData?.is_govt_officer,
    }));
  }
  function changecapacityPlanningCheckBox() {
    setCheckBoxData((prv: CheckBoxType) => ({
      ...prv,
      is_track_scheduling: !checkBoxData.is_track_scheduling,
    }));
  }

  function changeManagerFieldCheckBox() {
    setCheckBoxData((prv: CheckBoxType) => ({
      ...prv,
      is_manager_field: !checkBoxData.is_manager_field,
    }));
  }

  function changeTrackEfficiencyCheckBox() {
    setCheckBoxData((prv: CheckBoxType) => ({
      ...prv,
      is_track_efficiency: !checkBoxData.is_track_efficiency,
    }));
  }

  useEffect(() => {
    setProfileForm((prv: UserProfileType) => {
      return {
        ...prv,
        hr_settings: {
          ...prv.hr_settings,
          is_govt_officer: checkBoxData?.is_govt_officer,
          work_details: {
            ...prv?.hr_settings?.work_details,
            ...checkBoxData,
          },
        },
      };
    });
  }, [checkBoxData]);

  const handleSetWorkStatusRadioValue = (radioValue: string) => {
    setWeekDays(+radioValue);
    setProfileForm((prv: UserProfileType) => {
      return {
        ...prv,
        hr_settings: {
          ...prv.hr_settings,
          working_days: +radioValue,
          work_details: {
            ...prv?.hr_settings?.work_details,
          },
        },
      };
    });
  };

  const handleChangeLeave = (data: any) => {
    setProfileForm((prv: UserProfileType) => {
      return {
        ...prv,
        hr_settings: {
          ...prv.hr_settings,
          leave_balance: data ? +data : null,
          work_details: {
            ...prv?.hr_settings?.work_details,
          },
        },
      };
    });
  };

  const handleChangeWFH = (data: any) => {
    setProfileForm((prv: UserProfileType) => {
      return {
        ...prv,
        hr_settings: {
          ...prv.hr_settings,
          work_from_home_balance: data ? +data : null,
          work_details: {
            ...prv?.hr_settings?.work_details,
          },
        },
      };
    });
  };

  const handleEmploymentStatusChange = (data: any) => {
    setProfileForm((prv: UserProfileType) => {
      return {
        ...prv,
        hr_settings: {
          ...prv.hr_settings,
          employment_status: data?.value,
        },
      };
    });
    if (
      data?.value === "Intern" ||
      data?.value === "Probation" ||
      data?.value === "" ||
      data?.value === "Part time"
    ) {
      setProfileForm((prv: UserProfileType) => {
        return {
          ...prv,
          hr_settings: {
            ...prv.hr_settings,
            leave_balance: null,
          },
        };
      });
    }
  };

  const handleBackDatedTimesheetToggle = () => {
    setProfileForm((prv: UserProfileType) => {
      return {
        ...prv,
        hr_settings: {
          ...prv.hr_settings,
          enable_backdated_timesheet_entry: !data?.enable_backdated_timesheet_entry,
        },
      };
    });
  };

  return (
    <div className="form-group" style={{ marginTop: "15px" }}>
      <p style={{ fontSize: "20px", fontWeight: 500, marginBottom: "6px" }}>
        HR Settings
      </p>
      <h4 style={{ marginBottom: "29px", color: "#5c6177" }}>
        Update HR settings here
      </h4>
      <h6 style={{ marginBottom: "8px" }}>WORK DETAILS</h6>
      <div className="row">
        <div className="col-md-3">
          <label htmlFor="gender">User Branch </label>

          <Select<any, false>
            inputProps={{ autoComplete: "nope" }}
            placeholder={"Select User Branch"}
            options={branchList}
            value={selectBranch}
            onChange={handleBranch}
            onMenuScrollToBottom={() => checkBottom()}
            onMenuClose={() => {
              setOffset(0);
            }}
            onInputChange={(e: string) => {
              setSearchBranch(e);
              setOffset(0);
            }}
            isLoading={masterDataFetching}
          />
        </div>


        {!show && (
          <div className="col-md-3">
            <label htmlFor="gender">Employment Status </label>

            <Select<any, false>
              inputProps={{ autoComplete: "nope" }}
              placeholder={"Select"}
              options={EMPLOYMENT_STATUS}
              value={
                data &&
                data?.employment_status && {
                  label: data?.employment_status,
                  value: data?.employment_status,
                }
              }
              onChange={handleEmploymentStatusChange}
            />
          </div>
        )}
      </div>


      {data?.channel_partner ? <div className="col-md-3">
        <label htmlFor="gender">Channel Partner</label>

        <input
          className={`form-control`}
          name="leave_balance"
          disabled={true}
          value={data?.channel_partner}
        />
      </div> : null}

      {show && (
        <div className="row mt-2">
          <div className="col-md-3">
            <div className="d-flex align-items-start justify-content-start mt-3 mb-2 ">
              <input
                type="checkbox"
                name="is_govt_field"
                style={{
                  width: "19px",
                  height: "19px",
                  backgroundColor: "red",
                  accentColor: " #dd4433",
                }}
                onChange={changeGovtFieldCheckBox}
                className="checkbox"
                defaultChecked={data?.is_govt_officer}
              />
              <div>
                <small
                  className="ml-2"
                  style={{ fontSize: "14px", color: "#262a44" }}
                >
                  Display name in Officer's Directory
                </small>
              </div>
            </div>
          </div>
        </div>
      )}

      {!show && (
        <div className="row mt-2">
          <div className="col-md-3">
            <div className="d-flex align-items-start justify-content-start mt-3 mb-2 ">
              <input
                type="checkbox"
                name="is_partner_field"
                style={{
                  width: "19px",
                  height: "19px",
                  backgroundColor: "red",
                  accentColor: " #dd4433",
                }}
                onChange={changePartnerFieldCheckBox}
                className="checkbox"
                defaultChecked={data?.work_details?.is_partner_field}
              />
              <div>
                <small
                  className="ml-2"
                  style={{ fontSize: "14px", color: "#262a44" }}
                >
                  Display name in Partner field
                </small>
              </div>
            </div>
          </div>
          <div className="col-md-4">
            <div className="d-flex mt-3 mb-2">
              <input
                type="checkbox"
                name="is_track_scheduling"
                style={{
                  width: "19px",
                  height: "19px",
                  backgroundColor: "red",
                  accentColor: " #dd4433",
                }}
                defaultChecked={data?.work_details?.is_track_scheduling}
                onChange={changecapacityPlanningCheckBox}
                className="checkbox"
              />
              <small
                className="ml-2"
                style={{ fontSize: "14px", color: "#262a44" }}
              >
                Track Scheduling for User
              </small>
            </div>
          </div>
        </div>
      )}

      {!show && (
        <div className="row">
          <div className="col-md-3">
            <div className="d-flex mt-3 mb-2">
              <input
                type="checkbox"
                name="is_manager_field"
                style={{
                  width: "19px",
                  height: "19px",
                  backgroundColor: "red",
                  accentColor: " #dd4433",
                }}
                defaultChecked={data?.work_details?.is_manager_field}
                onChange={changeManagerFieldCheckBox}
                className="checkbox"
              />
              <small
                className="ml-2"
                style={{ fontSize: "14px", color: "#262a44" }}
              >
                Display name in Manager field
              </small>
            </div>
          </div>
          <div className="col-md-3">
            <div className="d-flex mt-3 mb-2">
              <input
                type="checkbox"
                name="is_track_efficiency"
                onChange={changeTrackEfficiencyCheckBox}
                style={{
                  width: "19px",
                  height: "19px",
                  backgroundColor: "red",
                  accentColor: " #dd4433",
                }}
                defaultChecked={data?.work_details?.is_track_efficiency}
                className="checkbox"
              />
              <small
                className="ml-2"
                style={{ fontSize: "14px", color: "#262a44" }}
              >
                Track Efficiency for user
              </small>
            </div>
          </div>
        </div>
      )}
      {!show && (
        <h6 className=" mt-3" style={{ marginBottom: "8px" }}>
          LEAVE SETTINGS
        </h6>
      )}
      <div className="row mt-3">
        {!show && (
          <div className="col-md-3">
            <label htmlFor="gender">User Leave Balance </label>

            <input
              type="number"
              className={`form-control`}
              name="leave_balance"
              disabled={
                !data?.employment_status ||
                (data?.employment_status &&
                  data?.employment_status === "Intern") ||
                (data?.employment_status &&
                  data?.employment_status === "Probation") ||
                (data?.employment_status &&
                  data?.employment_status === "Part time")
              }
              value={data?.leave_balance ? data?.leave_balance : ""}
              onChange={(e) => handleChangeLeave(e?.target?.value)}
              onWheel={(event) => event.currentTarget.blur()}
            />
          </div>
        )}

        {!show && (
          <div className="col-md-3">
            <label htmlFor="gender">User WFH Balance </label>

            <input
              type="number"
              className={`form-control`}
              name="WFH_balance"
              disabled={
                !data?.employment_status ||
                (data?.employment_status &&
                  data?.employment_status === "Intern") ||
                (data?.employment_status &&
                  data?.employment_status === "Part time")
              }
              value={
                data?.work_from_home_balance ? data?.work_from_home_balance : ""
              }
              onChange={(e) => handleChangeWFH(e?.target?.value)}
              onWheel={(event) => event.currentTarget.blur()}
            />
          </div>
        )}
      </div>
      {!show && data?.employment_status !== "Part time" && (
        <div className=" mt-3">
          <label htmlFor="work">Work week day </label>
          <div className="mt-2 d-flex align-items-center">
            <RadioContainer
              optionsList={DAY_STATUS_RADIO_OPTIONS}
              handleSetRadioValue={handleSetWorkStatusRadioValue}
              radioValue={weekDays?.toString()}
              alignment="horizontal"
            />
          </div>
        </div>
      )}
      {!show && (
        <div className="mt-3">
          <label htmlFor="Disable User" className="mr-2 mb-2">
            Enable backdated timesheet entry?
          </label>
          <ToggleSwitch
            handleToggleChange={handleBackDatedTimesheetToggle}
            isChecked={data?.enable_backdated_timesheet_entry}
          />
        </div>
      )}


    </div>
  );
};

const mapStateToProps = (state: RootState) => ({
  token: state.auth.token,
  fetching: state.masterData.fetching,
  statusCode: state.masterData.statusCode,
  error: state.masterData.error,
  masterDataListing: state.masterData.masterDataListing,
  success: state.masterData.success,
  message: state.masterData.message,
  masterDataBranchListTotal: state.masterData.masterDataBranchListTotal,
  masterDataFetching: state.masterData.fetching,
});

const mapDispatchToProps = (dispatch: any) => ({
  dispatchResetSession: () => dispatch(resetSession()),

  dispatchGetMasterDataBranch: (data: GetAllMasterDataBranchPayloadType) => {
    dispatch(getAllMasterDataBranchAction(data));
  },

  dispatchResetMasterSuccess: () => dispatch(resetMasterSuccess()),
  dispatchResetMasterError: () => dispatch(resetMasterError()),
  dispatchResetMasterMessage: () => dispatch(resetMasterMessage()),
});

export default connect(mapStateToProps, mapDispatchToProps)(WorkDetails);

// export default WorkDetails;
